import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const daysFilterColumns = ["Date", "Balance", "Yield Earned"];
export const monthFilterColumns = [
  "Date",
  "Average Balance",
  "Yield Earned",
  "Yield Credited",
];

export const DEFAULT_YIELD_PAGE_LIMIT = 10;
export const DEFAULT_YIELD_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: DEFAULT_YIELD_PAGE_LIMIT,
};
